<template>
  <v-layout row wrap>
    <v-flex xs12>
      <SummaryTitle
        :isCollapsible="isCollapsible"
        :isCollapsed="isCollapsed"
        icon="access_time"
        @clickedToggle="toggleIsCollapsed">
        Selected Time
        <template v-if="displayAction" v-slot:action>
          <EditButton @click="clickEditTime" />
        </template>
      </SummaryTitle>
    </v-flex>

    <template v-if="!contentIsCollapsed">
      <v-flex xs6>
        <p class="summary--sidebar-title">{{date(selectedDate)}}</p>
      </v-flex>

      <v-flex xs6 text-xs-right>
        <p class="summary--sidebar-title">{{simpleTime(selectedTime)}}</p>
      </v-flex>
    </template>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';
import { Mixins } from '@homegauge/vue';

import EditButton from '@/components/common/EditButton.vue';
import SummaryTitle from '@/components/common/SummaryTitle.vue';
import CollapsibleSection from '@/mixins/CollapsibleSection';
import StepUtilities from '@/router/utilities/step-utilities';

const { DateTime } = Mixins;

export default {
  components: {
    EditButton,
    SummaryTitle,
  },
  mixins: [CollapsibleSection, DateTime],
  computed: {
    ...mapState('Appointment', {
      selectedDate: state => state.dateComponentData.chosenDate,
      selectedTime: state => state.dateComponentData.time,
    }),
  },
  methods: {
    clickEditTime() {
      StepUtilities.goToScheduleStep(this.$router);
    },
  },
};
</script>
